import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSiteContext } from "../../contexts/SiteProvider";
import { ADMIN_USER_LOGO, LOGO, STR_LOGO, USER_LOGO } from "../../services/ImageService";
import SmartHoverSideNav from "./SmartHoverSideNav";
interface childrenProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}
const EFSideNav: React.FC<childrenProps> = ({ isOpen, setIsOpen }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout, settings } = useSiteContext();
  // console.log("logged in user ", user);
  const navigateLink = (index: any) => {
    navigate("/hims-" + index);
    if (window.innerWidth <= 768) {
      setIsOpen(false);
    }
  };
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      //setActive(false); // Close the dropdown when clicking outside
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const getSiteLogo = () => {
    if (settings && settings.st_site_company_logo) {
      //let img_content = JSON.parse(settings.st_site_company_logo);
      return `data:${settings.st_site_company_logo.type};base64,${settings.st_site_company_logo.content}`;
    } else {
      return LOGO;
    }
  };
  const getSiteLogo_footer = () => {
    if (settings && settings.st_site_company_footer_logo) {
      //let img_content = JSON.parse(settings.st_site_company_logo);
      return `data:${settings.st_site_company_footer_logo.type};base64,${settings.st_site_company_footer_logo.content}`;
    } else {
      return STR_LOGO;
    }
  };
  return (
    <>
      {/* Brand Logo */}
      <div className="brand-logo-title">
        <figure
          className={`image is-clickable  ${
            !isOpen ? "" : "m-0"
          }`}
        >
          <img
            className=""
            src={getSiteLogo()}
            alt=" "
            onClick={() => setIsOpen(!isOpen)}
          />
        </figure>
        {isOpen && <span className="header-text">{settings?.st_site_company_name || "EXAM"} </span>}
      </div>
      <div
        className="user-profile-image is-clickable ml-4"
        onClick={() => setIsOpen(!isOpen)}
      >
        {/* {isOpen && (
          <div
            className="side-bar-open-button "
            onClick={() => setIsOpen(!isOpen)}
          >
            <i
              className={isOpen ? "fa fa-angle-left" : "fa fa-angle-right"}
            ></i>
          </div>
        )} */}
      </div>

      <SmartHoverSideNav isOpen={isOpen} setIsOpen={(value) => setIsOpen(value)}/>
      <div
        className="side-nav-mobile-logout is-hidden-tablet"
        onClick={handleLogout}
      >
        <span className="icon">
          <i className="fa fa-sign-out"></i>
        </span>
        <span className="ml-2">Logout</span>
      </div>
      <div className=" side-nav-footer">
        <div
          className="user-profile-image is-clickable  mb-2"
          onClick={() => setIsOpen(!isOpen)}
        >
          <figure className="brand-logo-title ">
            <img className="" src={getSiteLogo_footer()} alt=" " />
          </figure>


          {isOpen && <p className="trining-text">
        Training Partner
          </p>}
        </div>


      </div>
    </>
  );
};
export default EFSideNav;
